/* eslint-ignore */
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import {
  BsChevronRight,
  BsChevronDown,
  BsSearch,
  BsCheck,
  BsQuestion,
  BsSafe2,
} from 'react-icons/bs';
import { BiCheckCircle } from 'react-icons/bi';
import { GrClose } from 'react-icons/gr';
import {
  GiHamburgerMenu,
  GiHouse,
  GiForkKnifeSpoon,
  GiRockingChair,
  GiDesk,
  GiDiploma,
  GiWineBottle,
} from 'react-icons/gi';
import {
  FaMoneyBillAlt,
  FaCannabis,
  FaChevronRight,
  FaLock,
  FaInfoCircle,
  FaCaretDown,
} from 'react-icons/fa';
import { RiSafe2Line } from 'react-icons/ri';
import { ImOffice } from 'react-icons/im';
import { VscEmptyWindow } from 'react-icons/vsc';
import {
  AiOutlineFolder,
  AiOutlinePrinter,
  AiOutlineIdcard,
  AiOutlineStock,
  AiFillWarning,
} from 'react-icons/ai';
import { TiMinus, TiPlus } from 'react-icons/ti';
import { IoBoat, IoBoatOutline, IoGolfOutline } from 'react-icons/io5';
import { IoCartOutline } from 'react-icons/io5';
import LogoSVG, { ReactComponent as LogoComponent } from './sonnet-logo.svg';
import NextArrowSVG, {
  ReactComponent as NextArrowComponent,
} from './next-arrow.svg';
import CheckCircleSVG, {
  ReactComponent as CheckCircleComponent,
} from './check-circle.svg';
import CalendarSVG, {
  ReactComponent as CalendarComponent,
} from './calendar.svg';
import AutoPlusSVG, {
  ReactComponent as AutoPlusComponent,
} from './auto-plus.svg';
import BottleSVG, { ReactComponent as BottleComponent } from './bottle.svg';
import VaseSVG, { ReactComponent as VaseComponent } from './vase.svg';
import StampSVG, { ReactComponent as StampComponent } from './stamp.svg';
import GolfCartSVG, {
  ReactComponent as GolfCartComponent,
} from './golf-cart.svg';
import RingSVG, { ReactComponent as RingComponent } from './ring.svg';
import SilverwareSVG, {
  ReactComponent as SilverwareComponent,
} from './silverware.svg';
import VaultSVG, { ReactComponent as VaultComponent } from './vault.svg';
import SpeedboatSVG, {
  ReactComponent as SpeedboatComponent,
} from './speedboat.svg';
import BicycleSVG, { ReactComponent as BicycleComponent } from './bicycle.svg';
import SofaSVG, { ReactComponent as SofaComponent } from './sofa.svg';
import SparePartsSVG, {
  ReactComponent as SparePartsComponent,
} from './spare-parts.svg';
import CannabisDerivativesSVG, {
  ReactComponent as CannabisDerivativesComponent,
} from './cannabis-derivatives.svg';
import BusinessPropertySVG, {
  ReactComponent as BusinessPropertyComponent,
} from './business-property.svg';
import CashCardsSVG, {
  ReactComponent as CashCardsComponent,
} from './cash-cards.svg';
import PersonalBelongingsSVG, {
  ReactComponent as PersonalBelongingsComponent,
} from './personal-belongings.svg';
import SecuritiesSVG, {
  ReactComponent as SecuritiesComponent,
} from './securities.svg';
import SoftwaresSVG, {
  ReactComponent as SoftwaresComponent,
} from './softwares.svg';
import CondoSVG, { ReactComponent as CondoComponent } from './condo.svg';
import DeductibleWaiverSVG, {
  ReactComponent as DeductibleWaiverComponent,
} from './deductible-waiver.svg';
import FirstClaimSVG, {
  ReactComponent as FirstClaimComponent,
} from './first-claim.svg';
import ReplacementCostGuaranteeSVG, {
  ReactComponent as ReplacementCostGuaranteeComponent,
} from './replacement-cost-guarantee.svg';
import PawSVG, { ReactComponent as PawComponent } from './paw.svg';
import ToolTipSVG, { ReactComponent as ToolTipComponent } from './tooltip.svg';
import PhoneBottomSVG, {
  ReactComponent as PhoneBottomComponent,
} from './phone-bottom.svg';
import LanguageEnSVG, {
  ReactComponent as LanguageEnComponent,
} from './language-en.svg';
import LanguageFrSVG, {
  ReactComponent as LanguageFrComponent,
} from './language-fr.svg';
import CartOutlineSVG, {
  ReactComponent as CartOutlineComponent,
} from './cart-outline.svg';
import CheckmarkNarrowSVG, {
  ReactComponent as CheckmarkNarrowComponent,
} from './checkmark-narrow.svg';
import CarAngularSVG, {
  ReactComponent as CarAngularComponent,
} from './h-car.svg';
import DriverAngularSVG, {
  ReactComponent as DriverAngularComponent,
} from './h-driver.svg';
import SecureSiteSVG, {
  ReactComponent as SecureSiteSVGComponent,
} from './secure-site.svg';

import WarningDiamondOutlineSVG, {
  ReactComponent as WarningDiamondOutlineSVGComponent,
} from './warning-diamond-outline.svg';

import { applyClasses, applyProps } from '../shared/js';
import styles from './icons.module.scss';

const Wrapper = ({ children, ...props }) => (
  <span
    className={cn(styles.icon, props.className, applyClasses(props, styles))}
    id={props.id}
    {...applyProps(props)}
  >
    {children}
  </span>
);

const IdCard = (props) => (
  <Wrapper {...props}>
    <AiOutlineIdcard />
  </Wrapper>
);

const Person = (props) => {
  const Component =
    typeof DriverAngularSVG === 'function'
      ? DriverAngularSVG
      : DriverAngularComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};

const Safe2 = (props) => (
  <Wrapper {...props}>
    <BsSafe2 />
  </Wrapper>
);
const Calendar = (props) => {
  const Component =
    typeof CalendarSVG === 'function' ? CalendarSVG : CalendarComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const Chevron = (props) => (
  <Wrapper {...props}>
    <BsChevronRight />
  </Wrapper>
);
const ChevronThick = (props) => (
  <Wrapper {...props}>
    <FaChevronRight />
  </Wrapper>
);
const ChevronDown = (props) => (
  <Wrapper {...props}>
    <BsChevronDown />
  </Wrapper>
);
const Close = (props) => (
  <Wrapper {...props}>
    <GrClose />
  </Wrapper>
);
const Logo = (props) => {
  const Component = typeof LogoSVG === 'function' ? LogoSVG : LogoComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const Hamburger = (props) => (
  <Wrapper {...props}>
    <GiHamburgerMenu />
  </Wrapper>
);
const NavClose = (props) => (
  <Wrapper {...props}>
    <GrClose />
  </Wrapper>
);
const Search = (props) => (
  <Wrapper {...props}>
    <BsSearch />
  </Wrapper>
);
const Checkmark = (props) => (
  <Wrapper {...props}>
    <BsCheck />
  </Wrapper>
);

const Checkmark2 = (props) => (
  <Wrapper {...props}>
    <BiCheckCircle />
  </Wrapper>
);

const House = (props) => (
  <Wrapper {...props}>
    <GiHouse />
  </Wrapper>
);
const QuestionMark = (props) => (
  <Wrapper {...props}>
    <BsQuestion />
  </Wrapper>
);
const NewWindow = (props) => (
  <Wrapper {...props}>
    <VscEmptyWindow />
  </Wrapper>
);
const Car = (props) => {
  const Component =
    typeof CarAngularSVG === 'function' ? CarAngularSVG : CarAngularComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const Plus = (props) => (
  <Wrapper {...props}>
    <TiPlus />
  </Wrapper>
);
const Minus = (props) => (
  <Wrapper {...props}>
    <TiMinus />
  </Wrapper>
);
const Cutlery = (props) => (
  <Wrapper {...props}>
    <GiForkKnifeSpoon />
  </Wrapper>
);
const RockingChair = (props) => (
  <Wrapper {...props}>
    <GiRockingChair />
  </Wrapper>
);
const Desk = (props) => (
  <Wrapper {...props}>
    <GiDesk />
  </Wrapper>
);
const Diploma = (props) => (
  <Wrapper {...props}>
    <GiDiploma />
  </Wrapper>
);
const Bill = (props) => (
  <Wrapper {...props}>
    <FaMoneyBillAlt />
  </Wrapper>
);

const Safe = (props) => (
  <Wrapper {...props}>
    <RiSafe2Line />
  </Wrapper>
);
const Office = (props) => (
  <Wrapper {...props}>
    <ImOffice />
  </Wrapper>
);
const Folder = (props) => (
  <Wrapper {...props}>
    <AiOutlineFolder />
  </Wrapper>
);
const Boat = (props) => (
  <Wrapper {...props}>
    <IoBoatOutline />
  </Wrapper>
);
const Boat2 = (props) => (
  <Wrapper {...props}>
    <IoBoat />
  </Wrapper>
);
const Golf = (props) => (
  <Wrapper {...props}>
    <IoGolfOutline />
  </Wrapper>
);
const Cart = (props) => (
  <Wrapper {...props}>
    <IoCartOutline />
  </Wrapper>
);
const Printer = (props) => (
  <Wrapper {...props}>
    <AiOutlinePrinter />
  </Wrapper>
);
const Cannabis = (props) => (
  <Wrapper {...props}>
    <FaCannabis />
  </Wrapper>
);
const Stock = (props) => (
  <Wrapper {...props}>
    <AiOutlineStock />
  </Wrapper>
);
const Wine = (props) => (
  <Wrapper {...props}>
    <GiWineBottle />
  </Wrapper>
);
const AutoPlus = (props) => {
  const Component =
    typeof AutoPlusSVG === 'function' ? AutoPlusSVG : AutoPlusComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const Warning = (props) => (
  <Wrapper {...props}>
    <AiFillWarning />
  </Wrapper>
);
const Lock = (props) => (
  <Wrapper {...props}>
    <FaLock />
  </Wrapper>
);
const Info = (props) => (
  <Wrapper {...props}>
    <FaInfoCircle />
  </Wrapper>
);
const DropdownArrow = (props) => (
  <Wrapper {...props}>
    <FaCaretDown />
  </Wrapper>
);
const NextArrow = (props) => {
  const Component =
    typeof NextArrowSVG === 'function' ? NextArrowSVG : NextArrowComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const CheckCircle = (props) => {
  const Component =
    typeof CheckCircleSVG === 'function'
      ? CheckCircleSVG
      : CheckCircleComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const Bottle = (props) => {
  const Component =
    typeof BottleSVG === 'function' ? BottleSVG : BottleComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const Vase = (props) => {
  const Component = typeof VaseSVG === 'function' ? VaseSVG : VaseComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const Stamp = (props) => {
  const Component = typeof StampSVG === 'function' ? StampSVG : StampComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const GolfCart = (props) => {
  const Component =
    typeof GolfCartSVG === 'function' ? GolfCartSVG : GolfCartComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const Ring = (props) => {
  const Component = typeof RingSVG === 'function' ? RingSVG : RingComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const Silverware = (props) => {
  const Component =
    typeof SilverwareSVG === 'function' ? SilverwareSVG : SilverwareComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const Vault = (props) => {
  const Component = typeof VaultSVG === 'function' ? VaultSVG : VaultComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const Speedboat = (props) => {
  const Component =
    typeof SpeedboatSVG === 'function' ? SpeedboatSVG : SpeedboatComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const Bicycle = (props) => {
  const Component =
    typeof BicycleSVG === 'function' ? BicycleSVG : BicycleComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const Sofa = (props) => {
  const Component = typeof SofaSVG === 'function' ? SofaSVG : SofaComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const SpareParts = (props) => {
  const Component =
    typeof SparePartsSVG === 'function' ? SparePartsSVG : SparePartsComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const CannabisDerivatives = (props) => {
  const Component =
    typeof CannabisDerivativesSVG === 'function'
      ? CannabisDerivativesSVG
      : CannabisDerivativesComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const BusinessProperty = (props) => {
  const Component =
    typeof BusinessPropertySVG === 'function'
      ? BusinessPropertySVG
      : BusinessPropertyComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const CashCards = (props) => {
  const Component =
    typeof CashCardsSVG === 'function' ? CashCardsSVG : CashCardsComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const PersonalBelongings = (props) => {
  const Component =
    typeof PersonalBelongingsSVG === 'function'
      ? PersonalBelongingsSVG
      : PersonalBelongingsComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const Securities = (props) => {
  const Component =
    typeof SecuritiesSVG === 'function' ? SecuritiesSVG : SecuritiesComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const Softwares = (props) => {
  const Component =
    typeof SoftwaresSVG === 'function' ? SoftwaresSVG : SoftwaresComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const Condo = (props) => {
  const Component = typeof CondoSVG === 'function' ? CondoSVG : CondoComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const DeductibleWaiver = (props) => {
  const Component =
    typeof DeductibleWaiverSVG === 'function'
      ? DeductibleWaiverSVG
      : DeductibleWaiverComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const FirstClaim = (props) => {
  const Component =
    typeof FirstClaimSVG === 'function' ? FirstClaimSVG : FirstClaimComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const ReplacementCostGuarantee = (props) => {
  const Component =
    typeof ReplacementCostGuaranteeSVG === 'function'
      ? ReplacementCostGuaranteeSVG
      : ReplacementCostGuaranteeComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const Paw = (props) => {
  const Component = typeof PawSVG === 'function' ? PawSVG : PawComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const Tooltip = (props) => {
  const Component =
    typeof ToolTipSVG === 'function' ? ToolTipSVG : ToolTipComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const PhoneBottom = (props) => {
  const Component =
    typeof PhoneBottomSVG === 'function'
      ? PhoneBottomSVG
      : PhoneBottomComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const LanguageEn = (props) => {
  const Component =
    typeof LanguageEnSVG === 'function' ? LanguageEnSVG : LanguageEnComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const LanguageFr = (props) => {
  const Component =
    typeof LanguageFrSVG === 'function' ? LanguageFrSVG : LanguageFrComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const CartOutline = (props) => {
  const Component =
    typeof CartOutlineSVG === 'function'
      ? CartOutlineSVG
      : CartOutlineComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const CheckmarkNarrow = (props) => {
  const Component =
    typeof CheckmarkNarrowSVG === 'function'
      ? CheckmarkNarrowSVG
      : CheckmarkNarrowComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};
const SecureSite = (props) => {
  const Component =
    typeof SecureSiteSVG === 'function'
      ? SecureSiteSVG
      : SecureSiteSVGComponent;
  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};

const WarningDiamondOutline = (props) => {
  const Component =
    typeof WarningDiamondOutlineSVG === 'function'
      ? WarningDiamondOutlineSVG
      : WarningDiamondOutlineSVGComponent;

  return (
    <Wrapper {...props}>
      <Component />
    </Wrapper>
  );
};

Wrapper.propTypes = {
  /** The ID of the icon element. Useful to select the form during testing. */
  id: PropTypes.string,
  /** A class name forwarded to the icon svg element */
  className: PropTypes.string,
  /** The icon component */
  children: PropTypes.any,
};

Wrapper.defaultProps = {
  className: undefined,
};

const Icons = {
  Calendar,
  Chevron,
  ChevronDown,
  ChevronThick,
  Close,
  Logo,
  Person,
  Hamburger,
  Checkmark2,
  NavClose,
  Search,
  Checkmark,
  Paw,
  House,
  QuestionMark,
  NewWindow,
  Car,
  Plus,
  Ring,
  Stamp,
  Cutlery,
  RockingChair,
  Desk,
  Diploma,
  Bicycle,
  Bill,
  Safe,
  Office,
  Folder,
  Boat,
  Boat2,
  Golf,
  Cart,
  Printer,
  AutoPlus,
  Safe2,
  IdCard,
  Cannabis,
  Stock,
  Vase,
  Wine,
  Warning,
  Lock,
  Minus,
  Info,
  NextArrow,
  CheckCircle,
  DropdownArrow,
  Bottle,
  GolfCart,
  Silverware,
  Vault,
  Speedboat,
  Sofa,
  SpareParts,
  CannabisDerivatives,
  BusinessProperty,
  CashCards,
  PersonalBelongings,
  Securities,
  Softwares,
  Condo,
  DeductibleWaiver,
  FirstClaim,
  ReplacementCostGuarantee,
  Tooltip,
  PhoneBottom,
  LanguageEn,
  LanguageFr,
  CartOutline,
  CheckmarkNarrow,
  SecureSite,
  WarningDiamondOutline,
};

export default Icons;
